import React, { Component } from "react";
import { Button } from "../../../common/Button/Button";
import CheckBoxContainer from "../../../common/CheckboxContainer/CheckboxContainer";
import moment from "moment";
import ReactDatePicker from "react-datepicker";

function SelectFollowupDateDropdown(props) {
  return (
    <>
		<ReactDatePicker
			dateFormat="dd/MM/yyyy"
			selected={props.followUpDateFrom}
			onChange={(date) =>
				props.setFollowUpDateFrom(date)
			}
			placeholderText="Follow up Date From"
		/>
		<ReactDatePicker
					dateFormat="dd/MM/yyyy"
					selected={props.followUpDateTo}
			onChange={(date) =>
			props.setFollowUpDateTo(date)
			}
			placeholderText="Follow up Date To"
		/>
	</>
  )
}

export default SelectFollowupDateDropdown;
